import {
  Box,
  Button,
  Heading,
  ModalProps,
  VStack,
  HStack,
  IconButton,
  Icon,
} from "@chakra-ui/react";
import useTranslate from "hooks/useTranslate";
import SimplePopup from "components/SimplePopup";
import {
  fancyBearsContract,
  hiveContract,
  honeyJarsContract,
  honeyTokenContract,
  v2Contract,
  v2Name,
  v2SaleContract,
} from "config";
import TinyHeading from "components/TinyHeading";
import { FaExternalLinkAlt } from "react-icons/fa";
import CopyInput from "components/CopyInput";
import { plural } from "pluralize";

type ContractsPopupProps = Omit<ModalProps, "children"> & {};

type ContractInfoBoxProps = {
  name: string;
  address: string;
};

const ContractInfoBox = ({ name, address }: ContractInfoBoxProps) => (
  <Box
    key={address}
    borderRadius="lg"
    bg="dark.800"
    color="bright.50"
    p="3"
    w="full"
  >
    <TinyHeading opacity="0.6" mb="1">
      {name}
    </TinyHeading>

    <HStack w="full" spacing="3">
      <CopyInput value={address} size="md" />
      <IconButton
        as="a"
        href={`https://etherscan.io/address/${address}`}
        target="_blank"
        aria-label=""
        size="xs"
        colorScheme="dark"
        borderRadius="full"
        color="primary.500"
        icon={<Icon as={FaExternalLinkAlt} w="3" h="3" />}
      />
    </HStack>
  </Box>
);

const ContractsPopup = ({ onClose, ...rest }: ContractsPopupProps) => {
  const translate = useTranslate();

  return (
    <SimplePopup size="md" onClose={onClose} {...rest}>
      <VStack w="full" textAlign="center" pt="8">
        <Heading fontSize="2xl" lineHeight="1.3" fontWeight="bold">
          {translate("common:contracts")}
        </Heading>
      </VStack>

      <Box
        px={{
          base: "0",
          sm: "2",
        }}
        mt="4"
      >
        <VStack spacing="2px">
          <ContractInfoBox name={plural(v2Name)} address={v2Contract.address} />
          <ContractInfoBox
            name={`${plural(v2Name)} Sale`}
            address={v2SaleContract.address}
          />
          <ContractInfoBox
            name="Honey Jars"
            address={honeyJarsContract.address}
          />
          <ContractInfoBox
            name="Fancy Bears"
            address={fancyBearsContract.address}
          />
          <ContractInfoBox
            name="HONEY Token"
            address={honeyTokenContract.address}
          />
          <ContractInfoBox name="Hive" address={hiveContract.address} />
        </VStack>

        <Button w="full" colorScheme="dark" mt="6" onClick={onClose}>
          {translate("common:close")}
        </Button>
      </Box>
    </SimplePopup>
  );
};

export default ContractsPopup;
